import React from 'react'
import styledComponents from '../styles/LogoHeader-style.js'
const { CustomHeader, CustomLogo, LogoImg, LogoTitle, SubTitle } = styledComponents;

const LogoHeader = () => {
    return (
        <CustomHeader>
            <CustomLogo>
                <LogoImg alt="BlueCarbon" src="./images/BCLogo.svg" />
                <LogoTitle>국가 블루카본 정보시스템</LogoTitle>

            </CustomLogo>
            {/* <SubTitle>블루카본 지킴이</SubTitle> */}
            {/* <SubTitle>
                지구를 지키는 블루카본
                <Title>대한민국의 푸른탄소 3총사를 소개할게요.</Title>
            </SubTitle> */}
        </CustomHeader>
    )
}

export default LogoHeader;